export default "__VITE_ASSET__DM2qxlBX__"